
import React from "react";
import { Logo } from "@/components/common/Logo";

export const FooterLogo = () => {
  return (
    <div className="flex flex-col items-start">
      <div className="mb-4 relative group transition-all duration-300 transform">
        <Logo
          className="justify-start"
          showTagline={true}
          variant="light"
          size="md"
        />
        <div className="absolute inset-0 bg-primary/5 rounded-lg -z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
      </div>
      <p className="text-sm text-yarn-slate mt-2 pr-4 leading-relaxed">
        Where creativity takes shape. Patterns made by knitters, for the knitting community.
      </p>
      <p className="text-sm text-yarn-mulberry/90 mt-2 italic">
        Your patterns, your data - always
      </p>
    </div>
  );
};
